// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
import AppTabController from "../../services/app-tab-controller";

function RoleConfigurationItemTypeTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(20);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.ConfigurationItemTypeCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteRoleConfigurationItemType");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeToRole":
                self.ShowRoleConfigurationItemTypeDialog(self.Role.RoleId(), null, true);
                break;
            case "RemoveConfigurationItemTypeFromRole":
                if (self.SelectedConfigurationItemTypeRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteRoleConfigurationItemType(self.SelectedConfigurationItemTypeRow().OpenData);
                        }
                    });
                }
                break;
            case "EditRoleConfigurationItemType":
                if (self.SelectedConfigurationItemTypeRow() != null) {
                    self.ShowRoleConfigurationItemTypeDialog(self.Role.RoleId(), self.SelectedConfigurationItemTypeRow().ConfigurationItemTypeId, false);
                }
                break;
        }
    };
    self.SelectedConfigurationItemTypeId = ko.observable();
    self.SelectedConfigurationItemType = ko.observable();
    self.SelectedConfigurationItemType.subscribe(function () {
        self.AddRoleConfigurationItemType(self.SelectedConfigurationItemTypeId(), self.Role.RoleId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/GetRoleConfigurationItemTypeCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedConfigurationItemTypeRow(null);
            self.TotalRows(0);
            self.ConfigurationItemTypeCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.ConfigurationItemTypeCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddRoleConfigurationItemType = function (model, roleId) {
        tabPage.IsLoading(true);
        return Bao.post("UadmCustom/RoleTab/AddRoleConfigurationItemType", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            model: ko.map.toJS(model),
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteRoleConfigurationItemType = function (roleConfigurationItemTypeId) {
        return Bao.post("UadmCustom/RoleTab/DeleteRoleConfigurationItemType", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleConfigurationItemTypeId: roleConfigurationItemTypeId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowConfigurationItemTypeTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("ConfigurationItemType");
            newTab.UrlData({
                id: item.ConfigurationItemTypeId
            });
            newTab.ObjectId(item.ConfigurationItemTypeId);
            AppTabController.AddTab(newTab);
        }
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("500px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                var shouldReturn = false;
                if (self.Dialog.ViewModel().IsRoleConfigurationItemTypeNew()) {
                    $.each(self.ConfigurationItemTypeCollection(), function (index, item) {
                        if (item.ConfigurationItemTypeId == self.Dialog.ViewModel().ConfigurationItemTypeId()) {
                            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgRoleConfigurationItemTypeExists"), "info");
                            shouldReturn = true;
                        }
                    });
                }
                if (shouldReturn) {
                    return;
                }
                if (!Bao.Utils.String.IsNullOrEmpty(self.Dialog.ViewModel().ConfigurationItemTypeId())) {
                    self.Dialog.IsLoading(true);
                    self.AddRoleConfigurationItemType(self.Dialog.ViewModel(), self.Role.RoleId());
                    self.Dialog.Close();
                    self.Dialog.IsLoading(false);
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowRoleConfigurationItemTypeDialog = function (roleId, ConfigurationItemTypeId, isNew) {
        return Bao.post("UadmCustom/RoleTab/ShowRoleConfigurationItemTypeDialog", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: roleId,
            ConfigurationItemTypeId: ConfigurationItemTypeId,
            isNew: isNew
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedConfigurationItemTypeRow = ko.observable({});
    self.SelectedConfigurationItemTypeRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RemoveConfigurationItemTypeFromRole":
                case "EditRoleConfigurationItemType":
                    button.Enabled(!(self.SelectedConfigurationItemTypeRow() == null));
                    break;
                case "AddConfigurationItemTypeToRole":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCustom/RoleTab/ResetRoleConfigurationItemType", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCustom/RoleTab/SaveRoleConfigurationItemTypeCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("UadmCustom/RoleTab/CopyRoleConfigurationItemTypeCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
}
;
export default RoleConfigurationItemTypeTabModel;